import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhatsappBotComponent } from './whatsapp-bot.component';
import { MatFormFieldModule, MatInputModule, MatSlideToggleModule } from '@angular/material';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { WhatsappBotRoutingModule } from '../whatsapp-bot-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TemplateEditModalComponent } from './template-edit-modal/template-edit-modal.component';
@NgModule({
  declarations: [WhatsappBotComponent, TemplateEditModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    CoreModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    WhatsappBotRoutingModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule
  ],
  entryComponents: [TemplateEditModalComponent]
})
export class WhatsappBotModule {}
